/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Insert_Event_AboveInputs */

const en_shortcut_keys_name_insert_event_above = /** @type {(inputs: Shortcut_Keys_Name_Insert_Event_AboveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert Event (Above)`)
};

const fr_shortcut_keys_name_insert_event_above = /** @type {(inputs: Shortcut_Keys_Name_Insert_Event_AboveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserer un evenement (au-dessus)`)
};

const de_shortcut_keys_name_insert_event_above = /** @type {(inputs: Shortcut_Keys_Name_Insert_Event_AboveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis einfügen (oben)`)
};

const it_shortcut_keys_name_insert_event_above = /** @type {(inputs: Shortcut_Keys_Name_Insert_Event_AboveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci evento (sopra)`)
};

const ru_shortcut_keys_name_insert_event_above = /** @type {(inputs: Shortcut_Keys_Name_Insert_Event_AboveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить событие (выше)`)
};

const es_shortcut_keys_name_insert_event_above = /** @type {(inputs: Shortcut_Keys_Name_Insert_Event_AboveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar evento (arriba)`)
};

const zh_cn2_shortcut_keys_name_insert_event_above = /** @type {(inputs: Shortcut_Keys_Name_Insert_Event_AboveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入事件（上方）`)
};

const ja_shortcut_keys_name_insert_event_above = /** @type {(inputs: Shortcut_Keys_Name_Insert_Event_AboveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントを挿入（上）`)
};

const hi_shortcut_keys_name_insert_event_above = /** @type {(inputs: Shortcut_Keys_Name_Insert_Event_AboveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट डालें (ऊपर)`)
};

const pt_pt2_shortcut_keys_name_insert_event_above = /** @type {(inputs: Shortcut_Keys_Name_Insert_Event_AboveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir evento (acima)`)
};

/**
* | output |
* | --- |
* | "Insert Event (Above)" |
*
* @param {Shortcut_Keys_Name_Insert_Event_AboveInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_insert_event_above = /** @type {((inputs?: Shortcut_Keys_Name_Insert_Event_AboveInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Insert_Event_AboveInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_insert_event_above(inputs)
	if (locale === "de") return de_shortcut_keys_name_insert_event_above(inputs)
	if (locale === "it") return it_shortcut_keys_name_insert_event_above(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_insert_event_above(inputs)
	if (locale === "es") return es_shortcut_keys_name_insert_event_above(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_insert_event_above(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_insert_event_above(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_insert_event_above(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_insert_event_above(inputs)
	return en_shortcut_keys_name_insert_event_above(inputs)
});